import * as React from 'react';
import { useCopilotChat_unstable } from './useCopilotChat';
import { renderCopilotChat_unstable } from './renderCopilotChat';
import { useCopilotChatStyles_unstable } from './useCopilotChatStyles.styles';
import type { CopilotChatProps } from './CopilotChat.types';
import type { ForwardRefComponent } from '@fluentui/react-components';

// CopilotChat component - TODO: add more docs
export const CopilotChat: ForwardRefComponent<CopilotChatProps> = React.forwardRef((props, ref) => {
  const state = useCopilotChat_unstable(props, ref);

  useCopilotChatStyles_unstable(state);
  return renderCopilotChat_unstable(state);
});

CopilotChat.displayName = 'CopilotChat';
